module.exports = __webpack_public_path__ + "img/fsni_5.9b6de24c.jpg";